import { useCallback, useState } from 'react'

export const useColumnsManager = ({ onReorder, lockedCount = 0 } = {}) => {
	const [isOpen, setIsOpen] = useState(true)

	const toggleOpen = useCallback(() => {
		setIsOpen(v => !v)
	}, [])

	const onDragEnd = useCallback(
		result => {
			if (!result?.destination) return

			const from = result.source.index
			const to = result.destination.index
			if (from === to) return

			// visible list index -> store index
			onReorder?.(from + lockedCount, to + lockedCount)
		},
		[onReorder, lockedCount]
	)

	return { isOpen, toggleOpen, onDragEnd }
}
